import React, { useContext, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { handleSSOCallback } from '../utils/sso';
import { LoadingScreen, Loader } from './styles';
import { AccountContext } from './Accounts';
import apiConfig from '../config/api';

const SSOCallback: React.FC = () => {
  const navigate = useNavigate();
  const { providerId } = useParams<{ providerId: string }>();
  const [isProcessing, setIsProcessing] = useState(true);
  const [hasError, setHasError] = useState(false);
  const { completeSSOLogin } = useContext(AccountContext);

  useEffect(() => {
    const processCallback = async() => {
      try {
        const data = await handleSSOCallback(providerId);

        if (data?.authentication_result && data?.authentication_result.access_token) {
          // Use AccountContext method which handles broker parameter, cookie storage, postMessage, and authentication state
          completeSSOLogin(data.authentication_result);

          // Redirect to parent URI if stored, otherwise navigate to home
          const storedParentUri = localStorage.getItem('sso_parent_uri');
          if (storedParentUri) {
            // Clear the stored URI after use
            localStorage.removeItem('sso_parent_uri');
            // Use window.top to redirect the entire frame hierarchy
            if (window.top) {
              window.top.location.href = storedParentUri;
            } else {
              window.location.href = storedParentUri;
            }
          } else if (apiConfig.QMT_APP_URL) {

            if (window.top) {
              window.top.location.href = apiConfig.QMT_APP_URL;
            } else {
              window.location.href = apiConfig.QMT_APP_URL;
            }

          } else {
            // Fallback to home if no parent URI and no APP URI are stored
            navigate('/');
          }
        } else {
          console.error('Invalid SSO callback response');

          // Send error message to parent window, following the same pattern as successful login
          window.parent?.postMessage(
            JSON.stringify({
              name: 'login',
              error: true,
              message: 'SSO Authentication failed. Please try again.',
            }),
            '*'
          );

          // Don't navigate after error - let parent window handle the response
          setHasError(true);
          setIsProcessing(false);
        }
      } catch (error) {
        console.error('SSO callback error:', error);

        // Send error message to parent window for network/API errors
        window.parent?.postMessage(
          JSON.stringify({
            name: 'login',
            error: true,
            message: 'SSO Authentication failed. Please try again.',
          }),
          '*'
        );

        // Don't navigate after error - let parent window handle the response
        setHasError(true);
        setIsProcessing(false);
      } finally {
        setIsProcessing(false);
      }
    };

    processCallback();
  }, [navigate]);

  if (isProcessing) {
    return (
      <LoadingScreen>
        <Loader />
      </LoadingScreen>
    );
  }

  if (hasError) {
    return (
      <LoadingScreen>
        <div>Authentication failed. Please close this window and try again.</div>
      </LoadingScreen>
    );
  }

  return null;
};

export default SSOCallback;
